
import {httpGet} from "./api/axios_api";
import Constants from "../constants/constants";


export async function getNewsFeed(token, platformID) {
    let url = `${Constants.BACKEND_URL}/get-news-stories/${platformID}`;
    return httpGet(url, {}, token);
}



// WEBPACK FOOTER //
// ./src/modules/news_feed.js